import * as React from 'react';

import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {Illustration} from 'shells/illustrations/illustration';

import type {ExternalServiceType} from 'nutshell-graphql-types';

import {NoIntegrationsEmptyState} from '../../calls/no-integrations-empty-state';

import {getServiceNoun, getServiceNounPlural} from '../helpers';

import {InitialSyncEmptyState} from './initial-sync-empty-state';
import type {ExternalServiceTypeFrontend} from './types';

type Props = {
    isPerformingInitialSync: boolean;
    firstEnabledIntegrationType: ExternalServiceType | null | undefined;
    totalCount: number;
    serviceType: ExternalServiceType | ExternalServiceTypeFrontend;
    hasUnloggedMeetings: boolean;
};

export function LoggedTableEmptyState(props: Props) {
    if (props.totalCount === 0 && !props.hasUnloggedMeetings) {
        if (props.serviceType === 'PHONES' && !props.firstEnabledIntegrationType) {
            return <NoIntegrationsEmptyState />;
        }

        if (props.isPerformingInitialSync && props.firstEnabledIntegrationType) {
            return <InitialSyncEmptyState integrationType={props.firstEnabledIntegrationType} />;
        }
    }

    const serviceCategoryNounPlural = getServiceNounPlural(props.serviceType);

    return (
        <EmptyStateSmall
            title={`No ${serviceCategoryNounPlural} have been logged`}
            subtitle={`To view them here, log ${getServiceNoun(
                props.serviceType
            )} ${serviceCategoryNounPlural} as activities.`}
            icon={
                <div style={{width: 80, height: 80}}>
                    <Illustration src='cactus-empty-state' width='100%' height='100%' />
                </div>
            }
        />
    );
}
